const elementExists = function( element  , is_array = false ){
    let exists = element && typeof( element ) !== 'undefined' && element !== null 
    if( exists && is_array ){
      exists = element.length > 0
    } 
    return exists
  }
  
  export default elementExists